import React, { useEffect, useState} from 'react'
import { useForm } from 'react-hook-form';
import {sweetalert} from "../../App";
import UsersAPI from '../../network/UsersAPI';
import SystemAPI from '../../network/SystemAPI';
import InBetweenOverlay from '../InBetweenOverlay';

export default function ForgotPassword() {
    const [loading, setLoading] = useState(false)
    const [email, setEmail ] = useState(null)
    const [logoURL, setLogoURL] = useState('');
    const [branding, setBranding] = useState(null);
    const [buttonColorHexValue, setButtonColorHexValue] = useState('')
    const [productName, setProductName] = useState('')


    // Form Validations
    const [form, setForm] = useState({})
    const { register, handleSubmit, formState: { errors }, trigger, reset} = useForm({
        mode: "onTouched"
    });
    const [isReset, setReset] = useState(false);
    
    useEffect(() => {
        reset(form);
        setReset(true);
    }, [reset, form]); // <= runs when reset state or form state updates

    useEffect(() => {
        isReset && trigger()
    }, [isReset]) // <= runs when trigger state or isReset state updates

    useEffect(() => {
        // Match patient portal branding: solid Midnight background.
        document.body.style.backgroundColor = '#291B2B';
        document.body.style.backgroundImage = 'none';

        setLoading(true)

        let currentURL = window.location.href;

        SystemAPI.getProductBrandingFromURL(currentURL).then(data => {
            setLogoURL(data.ProductAltLogoURL);
            setProductName(data.Name);
            setButtonColorHexValue(data.ProductButtonColorHexValue)
            setBranding(data)
            setLoading(false)
        })
        
        setForm({
            email: null
        })
    }, []) //<= runs on first load

    const onSubmit = async (data) => {
        try {
            let response = await UsersAPI.sendResetPasswordEmail(null, email, branding); // this calls our backend route which will actuall 
            if(!response.success){
                return sweetalert.fire({icon:'error',text: response.reason})
            } else {
                sweetalert.fire({ icon: 'success', text: 'Please check your email for instructions.' })
                    .then(() => {
                        //@ts-ignore
                        window['location'] = '/login' as unknown as Location;
                    })
            }
        }
        catch(e){
            console.error(e);
            return sweetalert.fire({text: e, icon: 'error'});
        }
        setLoading(false);
    }

    const onError = (e) => {
        console.error(e)
    }

    return (
        <>
        {/* <InBetweenOverlay showInBetween={true} zIndex={-10}/> */}
        <div className={loading ? "d-none" : "container  min-vh-100 d-flex flex-column justify-content-center"}>
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: '#291B2B', zIndex: -1, }}></div>
            <div className="row justify-content-center">
                <div className="col-lg-4 col-md-6 col-sm-6">
                    <div className="card shadow" style={{ backgroundColor: '#3A2240', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 20, color: '#FEFAFF' }}>
                        <div className="card-title text-center" style={{ borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
                            <a href="/">
                                <img src={logoURL}
                                    style={{ width: '200px', margin: '20px' }}
                                    className={'nav-logo'} alt={productName}
                                />
                            </a>
                        </div>
                        <div className="card-body">

                            <form onSubmit={(e) => handleSubmit(onSubmit,onError)(e).catch((e)=>{
                                console.error(' catch ',e)
                            })}>
                                <div className="mb-4">
                                    <label htmlFor="email" className="form-label">Username/Email</label>
                                    <input type="text" className="form-control" 
                                        id="email" name="email"
                                        {...register("email",{
                                            required:"Username/Email is required",
                                            pattern: {
                                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                message: 'Please verify email syntax.'
                                            },
                                        })}
                                        onChange={(e)=>{
                                            setEmail(e.target.value.trim())
                                            setForm({...form, 'email':e.target.value.trim() })
                                        }}
                                        />
                                    {errors.email && <small style={{ color: 'red' }} className={"error"}>{errors.email.message}</small>}
 
                                </div>
                                <div className="mb-4 text-center">
                                    <button type="submit"
                                        className="btn btn-lg col-12"
                                        style={{ backgroundColor: '#C9A8FB', color: '#291B2B', fontWeight: 600, borderRadius: 999 }}
                                        disabled={loading}
                                    >Reset Password</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    );
}